import { ReactElement } from "react";
import { Link } from "react-router-dom";

import logo from "@/assets/images/logo.webp";

export const Logo = (): ReactElement => {
  return (
    <Link to="/" className="logo">
      <img src={logo} alt={"logo dangwebs"} />
    </Link>
  );
};
